import { HttpMethod, PaginatedResponse, Type } from "@/Utils/request/types";
import { PatientRead } from "@/types/emr/patient/patient";
import { RoleBase } from "@/types/emr/role/role";

import {
  Organization,
  OrganizationCreate,
  OrganizationUpdate,
  OrganizationUserRole,
} from "./organization";

export interface AccessibleRoleOrganization {
  organization: Organization;
  role: RoleBase | null;
}

export default {
  listMine: {
    path: "/api/v1/organization/mine/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<Organization>>(),
  },
  list: {
    path: "/api/v1/organization/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<Organization>>(),
  },
  create: {
    path: "/api/v1/organization/",
    method: HttpMethod.POST,
    TRes: Type<Organization>(),
    TBody: Type<OrganizationCreate>(),
  },
  update: {
    path: "/api/v1/organization/{id}/",
    method: HttpMethod.PUT,
    TRes: Type<Organization>(),
    TBody: Type<OrganizationUpdate>(),
  },
  manageManagingOrganization: {
    path: "/api/v1/organization/{id}/managing_organization/",
    method: HttpMethod.POST,
    TRes: Type<Record<string, never>>(),
    TBody: Type<{ organization: string; action: "add" | "remove" }>(),
  },
  delete: {
    path: "/api/v1/organization/{id}/",
    method: HttpMethod.DELETE,
    TBody: Type<void>(),
    TRes: Type<void>(),
  },
  get: {
    path: "/api/v1/organization/{id}/",
    method: HttpMethod.GET,
    TRes: Type<Organization>(),
  },
  listUsers: {
    path: "/api/v1/organization/{id}/users/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<OrganizationUserRole>>(),
  },
  assignUser: {
    path: "/api/v1/organization/{id}/users/",
    method: HttpMethod.POST,
    TRes: Type<OrganizationUserRole>(),
    TBody: Type<{ user: string; role: string }>(),
  },
  updateUserRole: {
    path: "/api/v1/organization/{id}/users/{userRoleId}/",
    method: HttpMethod.PUT,
    TRes: Type<OrganizationUserRole>(),
    TBody: Type<{ user: string; role: string }>(),
  },
  removeUserRole: {
    path: "/api/v1/organization/{id}/users/{userRoleId}/",
    method: HttpMethod.DELETE,
    TRes: Type<void>(),
  },
  listPatients: {
    path: "/api/v1/patient/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<PatientRead>>(),
  },
  accessibleRoleOrganizations: {
    path: "/api/v1/organization/accessible_role_organizations/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<AccessibleRoleOrganization>>(),
  },
  getPublicOrganizations: {
    path: "/api/v1/govt/organization/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<Organization>>(),
  },
  getPublicOrganization: {
    path: "/api/v1/govt/organization/{id}/",
    method: HttpMethod.GET,
    TRes: Type<Organization>(),
  },
};
